import {
  ENTERPRISE_RECAPTCHA_ENABLED,
  GOOGLE_RECAPTCHA_SITE_KEY,
} from "config/envConfig";
import { NavProvider } from "context/navContext";
import { CookiesProvider } from "react-cookie";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { CartProvider } from "../context/cartContext";
import { ConfigProvider } from "../context/configContext";
import { DeliveryOptionProvider } from "../context/deliveryOptionContext";
import { FoodTypeProvider } from "../context/foodTypeContext";
import { UserProvider } from "../context/userContext";

const MainProvider = (props) => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={GOOGLE_RECAPTCHA_SITE_KEY}
      useEnterprise={ENTERPRISE_RECAPTCHA_ENABLED}
    >
      <CookiesProvider>
        <UserProvider>
          <DeliveryOptionProvider>
            <FoodTypeProvider>
              <ConfigProvider>
                <CartProvider>
                  <NavProvider>{props.children}</NavProvider>
                </CartProvider>
              </ConfigProvider>
            </FoodTypeProvider>
          </DeliveryOptionProvider>
        </UserProvider>
      </CookiesProvider>
    </GoogleReCaptchaProvider>
  );
};

export default MainProvider;
